// extracted by mini-css-extract-plugin
export default {"Text":"text_Text__cCVrq","TextHeader":"text_TextHeader__-AcPa","TextButtons":"text_TextButtons__3ZR9A","TextBody":"text_TextBody__ifdC8"};